/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpNetworkType } from '../models/GcpNetworkType';

export class GcpCloudSqlTarget {
  /**
  * Zone to restore to.
  */
  'zone': string;
  /**
  * Instance name.
  */
  'name': string;
  'networkType': GcpNetworkType;
  /**
  * Name of the VPC network to use.
  */
  'networkName'?: string;
  /**
  * Name of the subnet to use.
  */
  'subnetName'?: string;
  /**
  * ID of the project that hosts the VPC network. Applicable only when restoring to a shared VPC network. 
  */
  'networkHostProject'?: string;
  /**
  * Labels to apply to the restored Cloud SQL instance as key-value pairs, where key and value are both strings. These labels are always applied: `\"eon-restore\": \"true\"`.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'labels'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "zone",
      "baseName": "zone",
      "type": "string",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkType",
      "baseName": "networkType",
      "type": "GcpNetworkType",
      "format": ""
    },
    {
      "name": "networkName",
      "baseName": "networkName",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetName",
      "baseName": "subnetName",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkHostProject",
      "baseName": "networkHostProject",
      "type": "string",
      "format": ""
    },
    {
      "name": "labels",
      "baseName": "labels",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpCloudSqlTarget.attributeTypeMap;
  }

  public constructor() {
  }
}



